/* Zepto v1.1.6 - zepto event ajax form ie - zeptojs.com/license */



//js 的 linq 版
(function () {
    JSLINQ = window.$LQ = window.JSLINQ = function (dataItems) {
        return new JSLINQ.fn.init(dataItems);
    };

    JSLINQ.fn = JSLINQ.prototype = {
        init: function (dataItems) {
            this.items = dataItems;
        },

        // The current version of JSLINQ being used
        jslinq: "2.10",

        ToArray: function () { return this.items; },
        Where: function (clause) {
            var item;
            var newArray = new Array();
            // The clause was passed in as a Method that return a Boolean
            for (var index = 0; index < this.items.length; index++) {
                if (clause(this.items[index], index)) {
                    newArray[newArray.length] = this.items[index];
                }
            }
            return new JSLINQ(newArray);
        },
        Select: function (clause) {
            var item;
            var newArray = new Array();

            // The clause was passed in as a Method that returns a Value
            for (var i = 0; i < this.items.length; i++) {
                if (clause(this.items[i])) {
                    newArray[newArray.length] = clause(this.items[i]);
                }
            }
            return new JSLINQ(newArray);
        },
        OrderBy: function (clause) {
            var tempArray = new Array();
            for (var i = 0; i < this.items.length; i++) {
                tempArray[tempArray.length] = this.items[i];
            }
            return new JSLINQ(
                tempArray.sort(function (a, b) {
                    var x = clause(a);
                    var y = clause(b);
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                })
            );
        },
        OrderByDescending: function (clause) {
            var tempArray = new Array();
            for (var i = 0; i < this.items.length; i++) {
                tempArray[tempArray.length] = this.items[i];
            }
            return new JSLINQ(
                tempArray.sort(function (a, b) {
                    var x = clause(b);
                    var y = clause(a);
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                })
            );
        },
        SelectMany: function (clause) {
            var r = new Array();
            for (var i = 0; i < this.items.length; i++) {
                r = r.concat(clause(this.items[i]));
            }
            return new JSLINQ(r);
        },
        Count: function (clause) {
            if (clause == null)
                return this.items.length;
            else
                return this.Where(clause).items.length;
        },
        Distinct: function (clause) {
            var item;
            var dict = new Object();
            var retVal = new Array();
            for (var i = 0; i < this.items.length; i++) {
                item = clause(this.items[i]);
                // TODO - This doens't correctly compare Objects. Need to fix this
                if (dict[item] == null) {
                    dict[item] = true;
                    retVal[retVal.length] = item;
                }
            }
            dict = null;
            return new JSLINQ(retVal);
        },
        Any: function (clause) {
            for (var index = 0; index < this.items.length; index++) {
                if (clause(this.items[index], index)) { return true; }
            }
            return false;
        },
        All: function (clause) {
            for (var index = 0; index < this.items.length; index++) {
                if (!clause(this.items[index], index)) { return false; }
            }
            return true;
        },
        Reverse: function () {
            var retVal = new Array();
            for (var index = this.items.length - 1; index > -1; index--)
                retVal[retVal.length] = this.items[index];
            return new JSLINQ(retVal);
        },
        First: function (clause) {
            if (clause != null) {
                return this.Where(clause).First();
            }
            else {
                // If no clause was specified, then return the First element in the Array
                if (this.items.length > 0)
                    return this.items[0];
                else
                    return null;
            }
        },
        Last: function (clause) {
            if (clause != null) {
                return this.Where(clause).Last();
            }
            else {
                // If no clause was specified, then return the First element in the Array
                if (this.items.length > 0)
                    return this.items[this.items.length - 1];
                else
                    return null;
            }
        },
        ElementAt: function (index) {
            return this.items[index];
        },
        Concat: function (array) {
            var arr = array.items || array;
            return new JSLINQ(this.items.concat(arr));
        },
        Intersect: function (secondArray, clause) {
            var clauseMethod;
            if (clause != undefined) {
                clauseMethod = clause;
            } else {
                clauseMethod = function (item, index, item2, index2) { return item == item2; };
            }

            var sa = secondArray.items || secondArray;

            var result = new Array();
            for (var a = 0; a < this.items.length; a++) {
                for (var b = 0; b < sa.length; b++) {
                    if (clauseMethod(this.items[a], a, sa[b], b)) {
                        result[result.length] = this.items[a];
                    }
                }
            }

            return new JSLINQ(result);
        },
        DefaultIfEmpty: function (defaultValue) {
            if (this.items.length == 0) {
                return defaultValue;
            }
            return this;
        },
        ElementAtOrDefault: function (index, defaultValue) {
            if (index >= 0 && index < this.items.length) {
                return this.items[index];
            }
            return defaultValue;
        },
        FirstOrDefault: function (defaultValue) {
            return this.First() || defaultValue;
        },
        LastOrDefault: function (defaultValue) {
            return this.Last() || defaultValue;
        }
    };
    JSLINQ.fn.init.prototype = JSLINQ.fn;
})();

//js 语言配置
var $Language = {
    LanguageString: {
        No_upload_parameters_set: {
            EN: "",
            CN: "没有设置上传参数",
            CN_T: ""
        }, No_upload_button_found: {
            EN: "",
            CN: "没有找到上传按钮",
            CN_T: ""
        }, Has_exceeded_the_maximum_length: {
            EN: "",
            CN: "已超过最大长度{Number}",
            CN_T: ""
        }, Cannot_be_less_than_the_minimum_length: {
            EN: "",
            CN: "不能少于最小长度{Number}",
            CN_T: ""
        }, Can_not_be_less_than_the_minimum_value: {
            EN: "",
            CN: "不能少于最小值{Number}",
            CN_T: ""
        }, Has_exceeded_the_maximum_value: {
            EN: "",
            CN: "已经超过最大值{Number}",
            CN_T: ""
        }, Did_not_find_function: {
            EN: "",
            CN: "没找到方法",
            CN_T: ""
        }
        , Are_You_Sure: {
            EN: "",
            CN: "是否确定?",
            CN_T: ""
        }, Is_Delete: {
            EN: "",
            CN: "是否删除?",
            CN_T: ""
        }, Delete_Success: {
            EN: "",
            CN: "删除成功",
            CN_T: ""
        }, Successful: {
            EN: "",
            CN: "操作成功",
            CN_T: ""
        }, Role_DeleteTpis: {
            EN: "",
            CN: "删除角色会把有关联用户角色一并删除,确定删除么?",
            CN_T: ""
        }, password_not_match: {
            EN: "",
            CN: "新密码不一致",
            CN_T: ""
        }, Password_modification_success: {
            EN: "",
            CN: "密码修改成功,重新登录要使用新密码.",
            CN_T: ""
        }, Please_select_an_action_item: {
            EN: "",
            CN: "请选择操作项.",
            CN_T: ""
        }, Can_only_choose_one_operation: {
            EN: "",
            CN: "只能选择一个操作项.",
            CN_T: ""
        }
    },
    getStr: function (LanguageStringObj) { //获取字符
        var LanguageTag = $.cookie("$Language");
        if (LanguageTag) {
            return LanguageStringObj[LanguageTag] ? LanguageStringObj[LanguageTag] : "";
        } else {
            return LanguageStringObj.CN ? LanguageStringObj.CN : ""
        }
    },
    getLanguageTag: function () {
        var LanguageTag = $.cookie("$Language");
        return LanguageTag;
    }
}

$.extend($Language)



//查询数据有全屏遮蔽层
function zbc() {
    // &&window.$.cookie('LanguagesTag')=="CN"
    if (!window.document.getElementById('_____zbc')) {
        if(window.$.cookie('LanguagesTag')=="CN"){
            var html = '<div id="_____zbc" class="el-loading-mask is-fullscreen"  style="top: 0px;z-index:3000; width:100%; height: 100%;    background-color: hsla(0,0%,100%,0.5) ;filter:alpha(Opacity=50);-moz-opacity:0.5; position:fixed;"><div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div><div class="clearfix"><div id="_____progress"  style="width: 100%; height: 2px; position: absolute; top: -2px;"></div></div><div style="top: 60%;margin-top: -21px;width: 100%;text-align: center;position: absolute;color:#000;">Loading</div></div>';
         } else{
           var html = '<div id="_____zbc" class="el-loading-mask is-fullscreen"  style="top: 0px;z-index:3000; width:100%; height: 100%;    background-color: hsla(0,0%,100%,0.5) ;filter:alpha(Opacity=50);-moz-opacity:0.5; position:fixed;"><div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div><div class="clearfix"><div id="_____progress"  style="width: 100%; height: 2px; position: absolute; top: -2px;"></div></div><div style="top: 60%;margin-top: -21px;width: 100%;text-align: center;position: absolute;color:#000;">Loading</div></div>';
            
         }
       
        $(window.document.body).append(html)
    }
  
    return {
        show() {
            $("#_____zbc").show()
        },
        hide() {
            $("#_____zbc").hide()
        }
    }
}


//数组去重
export function uniq(array) {
    var temp = [];
    var index = [];
    var l = array.length;
    for (var i = 0; i < l; i++) {
        for (var j = i + 1; j < l; j++) {
            if (array[i] === array[j]) {
                i++;
                j = i;
            }
        }
        temp.push(array[i]);
        index.push(i);
    }
    console.log(index);
    return temp;
}


export function GetCountByStatus(Status, StatusAndCounts) {
    for (var i in StatusAndCounts) {
        var v = StatusAndCounts[i]
        if (v.Status == Status) {
            return v.Count;
        }
    }
    return 0;
}


export function $AjaxJson(url, data, callBack, isAsync, isNotzbcShow) {
    //console.log(url)
    //console.log(JSON.stringify(data))
    //console.log(window.rootVue)
    var Loading = window.rootVue.$Loading;
    if (!isNotzbcShow) {
        window.AjaxNumber = window.AjaxNumber ? (window.AjaxNumber + 1) : 1
    }
    var httpRequest =""
    if(url.indexOf('Upload/ImageFileUpload')!=-1){
        httpRequest="application/x-www-form-urlencoded"
    }else{
        httpRequest="application/json"
    }
    $.ajax({
        url: url,
        async: !isAsync,
        traditional: true,
        data: JSON.stringify(data),//第一个地方，需要进行JSON序列化
        type: 'POST',
        //dataType: 'json',
        contentType: httpRequest,//第二个地方，需要声明为'application/json'，默认'application/x-www-form-urlencoded'
        success: function (data, textStatus, xhr) {
            window.AjaxNumber--;
            if (window.AjaxNumber <= 0) {
                setTimeout(function () {
                    zbc().hide()
                }, 100);

                window.AjaxNumber = 0;
            }

            try {
                // console.log(xhr.getResponseHeader("LoginCheck"))
                if (xhr.getResponseHeader("LoginCheck") == "false" && url.indexOf('Sendmessagepassword')  == -1&& url.indexOf('ChangeUserPassword')  == -1) {
                   /// alert(111)
                    window.location.replace("/")
                }
            } catch (error) {
            }

            //console.log("-----------" + url + "-----------")
            //console.log(data)
            if (callBack) {
                callBack(data, textStatus)
            }



        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            window.AjaxNumber--;
            if (window.AjaxNumber <= 0) {
                setTimeout(function () {
                    zbc().hide()
                }, 100);
                window.AjaxNumber = 0;
            }


            try {
                Loading.error();
            } catch (e) { }
            alert(textStatus)
        },
        complete: function (XMLHttpRequest, textStatus) {
            // window.AjaxNumber --;
            // if(window.AjaxNumber<=0){
            //     setTimeout(function() {
            //         zbc().hide()
            //    }, 100);
            //    window.AjaxNumber =0;
            // }

            try {
                Loading.finish();
            } catch (e) { }
        },
        beforeSend: function () {
            zbc().show()
            try {
                Loading.start();
            } catch (e) { }
        }
    });
    //console.log('JSON.stringify(data)')
}


function isInteger(obj) {
    if (isNaN(obj)) {
        return false;
    }
    return true
}

var RegStr = {
    w: '[\\w\\u4E00-\\u9FA5\\+\\-\\*]+', //匹配中文、字母、数字和下划线 一个字符以上
    n: '^[\\d]+$',//只匹配数字 一个字符以上
    d: '^(-)?(([0-9]{1}\\d*)|([0]{1}))(\\.(\\d){1,6})?$', //只匹配 小数或整数
    all: '[\\s\\S]*' ,//匹配所有 不填也匹配
    allStr:'[\\s\\S]',//匹配所有 不能不填
}

export function ObjectCheck(j, Value) {

    var D_data = j ? j : { rex: 'all', tips: '' };
    var err = "";

    if (isInteger(Value)) {
        Value += ""
    }

    if (Value == null) {
        Value = ""
    }
    if (Value == undefined) {
        Value = ""
    }
    var mat;
    mat = Value.match(eval("/" + RegStr[D_data.rex] + "/gi"));

    var bc = true;
    if (mat == null) {
        bc = false;
        err = D_data.tips
    } else if (D_data.max && Value.length > D_data.max) {
        bc = false;
        err = $.getStr($.LanguageString.Has_exceeded_the_maximum_length).replace("{Number}", D_data.max);
    } else if (D_data.min && Value.length < D_data.min) {
        bc = false;
        err = $.getStr($.LanguageString.Cannot_be_less_than_the_minimum_length).replace("{Number}", D_data.min);
    } else if (D_data.maxvalue && !isNaN(Value) && parseFloat(Value) > D_data.maxvalue) {
        bc = false;
        err = $.getStr($.LanguageString.Has_exceeded_the_maximum_value).replace("{Number}", D_data.maxvalue);
    } else if (D_data.minvalue && !isNaN(Value) && parseFloat(Value) < D_data.minvalue) {
        bc = false;
        err = $.getStr($.LanguageString.Can_not_be_less_than_the_minimum_value).replace("{Number}", D_data.minvalue);
    }

    return {
        IsCheck: bc,
        error: err
    }
}



///集合取交集
Array.intersect = function () {
    var result = new Array();
    var obj = {};
    for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < arguments[i].length; j++) {
            var str = arguments[i][j];
            if (!obj[str]) {
                obj[str] = 1;
            }
            else {
                obj[str]++;
                if (obj[str] == arguments.length) {
                    result.push(str);
                }
            }//end else
        }//end for j
    }//end for i
    return result;
}

//集合去掉重复
Array.prototype.uniquelize = function () {
    var tmp = {},
        ret = [];
    for (var i = 0, j = this.length; i < j; i++) {
        if (!tmp[this[i]]) {
            tmp[this[i]] = 1;
            ret.push(this[i]);
        }
    }

    return ret;
}

//并集
Array.union = function () {
    var arr = new Array();
    var obj = {};
    for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < arguments[i].length; j++) {
            var str = arguments[i][j];
            if (!obj[str]) {
                obj[str] = 1;
                arr.push(str);
            }
        }//end for j
    }//end for i
    return arr;
}

//2个集合的差集 在arr不存在
Array.prototype.minus = function (arr) {
    var result = new Array();
    var obj = {};
    for (var i = 0; i < arr.length; i++) {
        obj[arr[i]] = 1;
    }
    for (var j = 0; j < this.length; j++) {
        if (!obj[this[j]]) {
            obj[this[j]] = 1;
            result.push(this[j]);
        }
    }
    return result;
};

// console.log(Array.intersect(["1", "2", "3"], ["2", "3", "4", "5", "6"]));//[2,3]
// console.log([1, 2, 3, 2, 3, 4, 5, 6].uniquelize());//[1,2,3,4,5,6]
// console.log(Array.union(["1", "2", "3"], ["2", "3", "4", "5", "6"], ["5", "6", "7", "8", "9"]))
// console.log(["2", "3", "4", "5", "6"].minus(["1", "2", "3"]));


export function GetFieldItem(fieldName, FieldData) {
    return new window.$LQ(FieldData).Where(function (e) { return e.field == fieldName }).FirstOrDefault()
}



export function RemoveFieldItem(fieldName, FieldData) {
    var b = false;
    var c = 0;
    for (var i of FieldData) {
        if (i.field == fieldName) {
            b = true;
            break;
        }
        c++;
    }

    if (b) {
        FieldData.splice(c, 1)
    }
}



Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,//月份
        "d+": this.getDate(),//日
        "H+": this.getHours(),//小时
        "m+": this.getMinutes(),//分
        "s+": this.getSeconds(),//秒
        "q+": Math.floor((this.getMonth() + 3) / 3),//季度
        "S+": this.getMilliseconds()//毫毛
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};


export function ExportPDF(docid, Name) {
    window.document.getElementById('__PrintPDFHTML').value = window.document.getElementById(docid).innerHTML;
    window.document.getElementById('__PrintPDFName').value = Name;

    var fm = window.document.getElementById("__PrintPDF");
    fm.submit();
}











// WEBPACK FOOTER //
// ./src/lf.js